import {TenantAPI} from "../api/TenantAPI"
import {AppStore} from "../desktop"
import {actionTenantFetchCompleted} from "../store/tenant/actions"
import {BaseService} from "./BaseService"
import {Tenant} from "../models/Tenant"
import {TenantActionTypes} from "../store/tenant"
import {actionDeleteTabForItemId, actionSetTabItem, actionSetTabStateItem} from "../store/tabs/actions"
import {ErrorService} from "./ErrorService"

export default class TenantService extends BaseService {

    static getOne(tabId: string) {

        let tenantAPI: TenantAPI = new TenantAPI()

        tenantAPI.get().then(TenantService.processResponse).then(result => {
			actionTenantFetchCompleted(TenantService.fromAPIItem(result), tabId)
        }).catch(error => ErrorService.handleError(error))

    }
    
    static save(tenant: Tenant) {

        let tenantAPI: TenantAPI = new TenantAPI()

		if (tenant.id) {
			tenantAPI.put(TenantService.itemToRequest(tenant)).then(TenantService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: TenantActionTypes.SAVE_COMPLETED, payload: TenantService.fromAPIItem(data)
					})
					actionSetTabStateItem(TenantService.fromAPIItem(data))
					actionSetTabItem(TenantService.fromAPIItem(data))
				}
			).catch(error => ErrorService.handleError(error))
		} else {

			tenantAPI.post(TenantService.itemToRequest(tenant)).then(TenantService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: TenantActionTypes.SAVE_COMPLETED, payload: TenantService.fromAPIItem(data)
					})
					actionSetTabStateItem(TenantService.fromAPIItem(data))
					actionSetTabItem(TenantService.fromAPIItem(data))
				}
			).catch(error => ErrorService.handleError(error))

		}
	}

    static fromAPIItem(apiItem: any): Tenant{
        let tenant = new Tenant()

        tenant.id = apiItem.id
        tenant.title = apiItem.name
		tenant.vatId = apiItem.vatId
		tenant.companyId = apiItem.companyId
		tenant.accountNumber = apiItem.accountNumber
		tenant.address = apiItem.address
		tenant.invoiceBackground = apiItem.invoiceBackground
		tenant.invoiceText = apiItem.invoiceText
		tenant.invoiceResponsible = apiItem.invoiceResponsible
		tenant.uploads = apiItem.uploads
		tenant.invoiceFooterImageId = apiItem.invoiceFooterImageId
		tenant.invoiceHeaderImageId = apiItem.invoiceHeaderImageId
		tenant.invoiceFooterImage = apiItem.invoiceFooterImage
		tenant.invoiceHeaderImage = apiItem.invoiceHeaderImage

        return tenant
    }

    static itemToRequest (tenant: Tenant): any {

		let itemRequest: any = {}

		if(tenant.id)
        itemRequest.id = tenant.id
		itemRequest.name = tenant.title
		itemRequest.vatId = tenant.vatId
		itemRequest.companyId = tenant.companyId
		itemRequest.accountNumber = tenant.accountNumber
		itemRequest.address = tenant.address
		itemRequest.invoiceBackground = tenant.invoiceBackground
		itemRequest.invoiceText = tenant.invoiceText
		itemRequest.invoiceResponsible = tenant.invoiceResponsible
		itemRequest.uploads = null
		itemRequest.invoiceHeaderImageId = tenant.invoiceHeaderImageId
		itemRequest.invoiceFooterImageId = tenant.invoiceFooterImageId
		itemRequest.invoiceHeaderImage = null
		itemRequest.invoiceFooterImage = null

		return itemRequest
	}
}
